import { useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { MdOutlineCreditCard } from 'react-icons/md';
import CircleIcon from 'components/CircleIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { displayAmount } from 'shared/helpers/common';
import { B2B_ENABLED } from 'shared/constants/appConfig';
import { getPaymentHistory } from 'services/CommonService';
import PaymentSummaryItem from './PaymentSummaryItem';
import MakeAPayment from './makeAPayment';

export default function PaymentsTab({ booking, refreshBookingAfterPayment }) {
  const { paid, due, currentPrice, currency, duePlan, balanceDueDate, reference } = booking;
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  const { componentConfig } = useSelector(
    (state) => state.ui,
  );
  const [paymentHistory, setPaymentHistory] = useState(null);

  const loadData = useCallback(async () => {
    try {
      if (componentConfig.bookingReceiptsEnabled) {
        const { data: paymentHistoryData } = await getPaymentHistory(reference);
        setPaymentHistory(paymentHistoryData);
      }
    } catch (error) {
      console.error(error);
    }
  }, [
    reference,
    componentConfig.bookingReceiptsEnabled,
  ]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <>
      <div className="mt-[60px] mb-[35px] flex items-start">
        <CircleIcon className="mt-1">
          <MdOutlineCreditCard style={{ fill: primaryColour }} />
        </CircleIcon>
        <SectionLabel label={`${B2B_ENABLED ? "Cost Summary" : "Payment Summary"}`} className="ml-[10px] mt-1" />
      </div>
      <PaymentSummaryItem
        label="Total price"
        amount={displayAmount(currentPrice, currency)}
      />
      {!B2B_ENABLED && (
        <>
          {paymentHistory?.assetPaymentTotal > 0 && (
            <PaymentSummaryItem
              label="Redeemed Assets"
              amount={displayAmount(paymentHistory.assetPaymentTotal, currency)}
            />
          )}

          <PaymentSummaryItem label="Paid" amount={displayAmount(paid, currency)} />

          <PaymentSummaryItem
            label="Due"
            amount={displayAmount(due, currency)}
            balanceDueDate={Object.keys(duePlan ?? {}).length === 0 ? balanceDueDate : ''}
          />

          {componentConfig.paymentEnabled && (
            <MakeAPayment refreshBookingAfterPayment={refreshBookingAfterPayment} />
          )}
        </>
      )}
    </>
  );
}
